import { lazy } from "react";

const routes = [
  { path: "/", element: lazy(() => import("../Components/Home/Home")) },
  { path: "/login", element: lazy(() => import("../Components/Auth/Login")) },
  {
    path: "/register-individual",
    element: lazy(() => import("../Components/Auth/Register")),
  },
  {
    path: "/forgot-password",
    element: lazy(() => import("../Components/Auth/ForgotPassword")),
  },
  {
    path: "/verification",
    element: lazy(() => import("../Components/Auth/Verification")),
  },
  {
    path: "/reset-password",
    element: lazy(() => import("../Components/Auth/ResetPassword")),
    // protected: true,
  },

  {
    path: "/select-profile",
    element: lazy(() => import("../Components/Auth/SelectProfile")),
    // protected: true,
  },
  {
    path: "/profile",
    element: lazy(() => import("../Components/Informations/MyProfile")),
    protected: true,
  },
  {
    path: "/profile-edit",
    element: lazy(() => import("../Components/Informations/MyProfileEdit")),
    protected: true,
  },

  {
    path: "/register-company",
    element: lazy(() => import("../Components/Auth/CreateCompany")),
    // protected: true,
  },
  {
    path: "/register-company-individual",
    element: lazy(() => import("../Components/Auth/CompanyIndividual")),
    // protected: true,
  },
  {
    path: "/card",
    element: lazy(() => import("../Components/Auth/Card")),
    protected: true,
  },
  {
    path: "/tender-news",
    element: lazy(() => import("../Components/TenderNews/AllTenderNews")),
    // protected: true,
  },
  {
    path: "/product-filter",
    element: lazy(() => import("../Components/Products/ProductFilter")),
    // protected: true,
  },
  {
    path: "/product-details/:id",
    element: lazy(() => import("../Components/Products/ProductDetails")),
    // protected: true,
  },
  {
    path: "/product-requirement-post",
    element: lazy(() => import("../Components/Informations/MyProductRP")),
    protected: true,
  },
  {
    path: "/my-document-details",
    element: lazy(() =>
      import("../Components/Informations/MyDocumentsDetails")
    ),
    protected: true,
  },
  {
    path: "/my-document-request",
    element: lazy(() => import("../Components/Informations/MyDocument")),
    protected: true,
  },
  {
    path: "/my-sample-request",
    element: lazy(() => import("../Components/Informations/MySampleRequest")),
    protected: true,
  },
  {
    path: "/my-quote",
    element: lazy(() => import("../Components/Informations/MyQuote")),
    protected: true,
  },
  {
    path: "/my-quote-details",
    element: lazy(() => import("../Components/Informations/MyQuoteDetails")),
    protected: true,
  },
  {
    path: "/my-order",
    element: lazy(() => import("../Components/Informations/MyOrder")),
    protected: true,
  },
  {
    path: "/my-order-request",
    element: lazy(() => import("../Components/Informations/MyOrderRequest")),
    protected: true,
  },
  {
    path: "/my-order-details/:id",
    element: lazy(() => import("../Components/Informations/MyOrderDetails")),
    protected: true,
  },
  {
    path: "/rfqs-details",
    element: lazy(() => import("../Components/Informations/RFQDetails")),
    protected: true,
  },
  {
    path: "/my-sample-details",
    element: lazy(() => import("../Components/Informations/MySampleDetails")),
    protected: true,
  },
  {
    path: "/pay-type",
    element: lazy(() => import("../Components/ProductPayment/Paylater")),
    protected: true,
  },
  {
    path: "/pay-now",
    element: lazy(() => import("../Components/ProductPayment/PayNow")),
    protected: true,
  },
  {
    path: "/tender-news-details",
    element: lazy(() => import("../Components/TenderNews/TenderNewsDetails")),
    // protected: true,
  },
  {
    path: "/seller-all",
    element: lazy(() => import("../Components/Seller/AllSeller")),
    // protected: true,
  },
  {
    path: "/seller-details",
    element: lazy(() => import("../Components/Seller/SellerDetails")),
    // protected: true,
  },
  {
    path: "/seller-view-profile",
    element: lazy(() => import("../Components/Seller/SellerViewOrder")),
    protected: true,
  },
  {
    path: "/my-track-order",
    element: lazy(() => import("../Components/Informations/MyTrackOrder")),
    protected: true,
  },
  {
    path: "/my-track-order-map",
    element: lazy(() => import("../Components/Informations/TrackMap")),
    protected: true,
  },
  {
    path: "/my-credit-card",
    element: lazy(() => import("../Components/Informations/MyCreditCard")),
    protected: true,
  },
  {
    path: "/my-subscription-plan",
    element: lazy(() => import("../Components/Informations/SubscriptionPlan")),
    protected: true,
  },
  {
    path: "/upgrade-plan",
    element: lazy(() => import("../Components/Informations/UpgradePlan")),
    protected: true,
  },
  {
    path: "/setting",
    element: lazy(() => import("../Components/Informations/Setting")),
    protected: true,
  },
  {
    path: "/faqs",
    element: lazy(() => import("../Components/Informations/MyFaq")),
    // protected: true,
  },
  {
    path: "/about-us",
    element: lazy(() => import("../Components/Content/AboutUs")),
    // protected: true,
  },
  {
    path: "/terms-and-conditions",
    element: lazy(() => import("../Components/Content/TermsAndConditions")),
    // protected: true,
  },
  {
    path: "/privacy-policy",
    element: lazy(() => import("../Components/Content/PrivacyPolicy")),
    // protected: true,
  },
  {
    path: "/help-and-support",
    element: lazy(() => import("../Components/Content/HelpAndSupport")),
    protected: true,
  },
  {
    path: "/chats",
    element: lazy(() => import("../Components/Chats/Chats")),
    protected: true,
  },

  // seller account start
  {
    path: "/seller-home",
    element: lazy(() => import("../Components/SellerFlow/SellerHome")),
    protected: true,
    seller: true,
  },
  {
    path: "/my-earning",
    element: lazy(() => import("../Components/SellerFlow/MyEarning")),
    protected: true,
    seller: true,
  },
  {
    path: "/seller-active-requirements",
    element: lazy(() => import("../Components/SellerFlow/ActiveRequirements")),
    protected: true,
    seller: true,
  },
  {
    path: "/seller-active-requirements-details",
    element: lazy(() =>
      import("../Components/SellerFlow/ActiveRequirementsDetails")
    ),
    protected: true,
    seller: true,
  },
  {
    path: "/seller-product",
    element: lazy(() => import("../Components/SellerFlow/Product")),
    protected: true,
    seller: true,
  },
  {
    path: "/seller-product-details/:id",
    element: lazy(() => import("../Components/SellerFlow/ProductDetails")),
    protected: true,
    seller: true,
  },
  {
    path: "/chatbot",
    element: lazy(() => import("../chatbotvikash/ChatbotWrapperv")),
    // protected: true,
    // seller: true,
  },
];
export default routes;
